import React from 'react';
import { Grid2, ListItemButton, Typography } from '@mui/material';
import { Link } from '@mui/material';
import { NavLink, useParams } from 'react-router-dom';
import { ContestRead } from '../../../../core/contests/types';
import { SectionTitle } from '../../../../design-library';
import TaskAltIcon from '@mui/icons-material/TaskAlt';
import BugReportIcon from '@mui/icons-material/BugReport';

interface ProblemNavigationSidebarProps {
	contestData: ContestRead;
	currentProblemId: number;
}

export default function ProblemNavigationSidebar({ contestData, currentProblemId }: ProblemNavigationSidebarProps) {
	const { contestSlug } = useParams<{ contestSlug: string }>();

	return (
		<Grid2 container spacing={2} sx={{ width: '100%' }}>
			<SectionTitle title={'Problems'} size={'small'} />
			{contestData.problem_set.map((problem) => {
				const isSelected = problem.problem_id === currentProblemId;
				return (
					<Grid2 key={problem.slug} size={12} sx={{ width: '100%' }}>
						<Link
							to={`/contests/${contestSlug}/problems/${problem.problem_order_character!}`}
							underline={'none'}
							component={NavLink}
							sx={{ width: '100%' }}
						>
							<ListItemButton
								selected={isSelected}
								sx={{
									border: 1,
									margin: '2px 0px',
									borderColor: 'rgba(0, 0, 0, 0.07)',
									backgroundColor: isSelected ? 'action.selected' : 'inherit',
									'&:hover': {
										backgroundColor: isSelected ? 'action.selected' : 'action.hover',
									},
									opacity: problem.is_visible ? 1 : 0.6,
									display: 'flex',
									alignItems: 'center',
									gap: 1,
									width: '100%',
								}}
							>
								<Typography
									variant='h5'
									color='primary'
									fontWeight='bold'
									sx={{
										minWidth: '32px',
										flexShrink: 0,
									}}
								>
									{problem.problem_order_character}
								</Typography>
								<Typography
									variant='body2'
									color='primary'
									sx={{
										overflow: 'hidden',
										textOverflow: 'ellipsis',
										whiteSpace: 'nowrap',
										flex: 1,
										minWidth: 0,
									}}
								>
									{problem.title}
								</Typography>
								{problem.submission_meta?.has_user_accepted ? (
									<TaskAltIcon color='success' fontSize='small' sx={{ flexShrink: 0 }} />
								) : problem.submission_meta?.user_tried > 0 ? (
									<BugReportIcon color='warning' fontSize='small' sx={{ flexShrink: 0 }} />
								) : null}
							</ListItemButton>
						</Link>
					</Grid2>
				);
			})}
		</Grid2>
	);
}
